import { useSite } from "@/context/SiteContext";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import useLenis from "@/hooks/useLenis";

export function SiteLayout({ children }) {
  useLenis();
  return (
    <div className="App">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
